import type { InferResponse } from '@/hooks/useApiClient'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useCounterparty = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const useCarrierNamesQuery = () =>
    useQuery({ queryKey: ['carrierNamesQuery'], queryFn: () => api.post('counterparty/carrier_names') })

  const useGetCounterpartiesQuery = (filter = {}) =>
    useQuery({
      queryKey: ['getCounterpartiesQuery', filter],
      queryFn: (queryKey) =>
        api.post('counterparty/overview', { filter: queryKey[1] }) as Promise<InferResponse<'/counterparty/overview'>>,
    })

  const useUpdateCounterpartyMutation = useMutation({
    mutationKey: ['updateCounterpartyMutation'],
    mutationFn: (counterparty) => api.post('counterparty/update', counterparty),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getCounterpartiesQuery'] })
    },
    onError: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getCounterpartiesQuery'] })
    },
  })

  return { useCarrierNamesQuery, useGetCounterpartiesQuery, useUpdateCounterpartyMutation }
}
